export const getActionTypeFn = (featureName: string) => (actionName: string) => {
    return `[${featureName}] ${actionName}`
}
